import React, { FC } from 'react';
import { ModelsListingModel } from './models/modelsListing.model';
import { TModelsListingProps } from './types/modelsListing.types';
import ModelsListItem from './components/modelsListItem';
import { appendToUrlPath } from '../../utils';
import MockedComponentMessage from '../mockedComponentMessage';
import { isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const ModelsListing: FC<TModelsListingProps> = (props) => {
  const model = new ModelsListingModel(props);
  const modelsItems = model?.modelsListData?.items || [];

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  if (!modelsItems && isEditorActive()) {
    return <MockedComponentMessage />;
  }
  if (!modelsItems && !isEditorActive()) {
    return <></>;
  }
  return (
    <div>
      <section className="models-listing">
        <div className="models-listing__container">
          <div className="models-listing__list">
            {modelsItems.map((modelsItem) => (
              <ModelsListItem url={appendToUrlPath(model.url || '', modelsItem.titleUrl)} item={modelsItem} key={modelsItem?.id} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default withSitecoreContext()(ModelsListing);
